module.exports = __webpack_public_path__ + "img/vr_logo.6655f6ac.png";